/**
 * DigitalOcean droplet sizes — labels + approximate monthly cost in USD (DigitalOcean list prices).
 *
 * Lives here (not in a Plans store) because these are infra facts about
 * the underlying provider, not part of any plan catalogue.
 */

export type DropletSize =
  | 'shared'
  | 's-1vcpu-2gb'
  | 's-2vcpu-4gb'
  | 's-4vcpu-8gb'
  | 's-8vcpu-16gb'
  | 's-16vcpu-32gb'
  | 'byo';

export const DROPLET_SIZE_LABEL: Record<DropletSize, string> = {
  shared: 'Shared pool (K8s namespace)',
  's-1vcpu-2gb': 'Small — 1 vCPU · 2 GB RAM',
  's-2vcpu-4gb': 'Standard — 2 vCPU · 4 GB RAM',
  's-4vcpu-8gb': 'Large — 4 vCPU · 8 GB RAM',
  's-8vcpu-16gb': 'Extra-large — 8 vCPU · 16 GB RAM',
  's-16vcpu-32gb': 'Performance — 16 vCPU · 32 GB RAM',
  byo: 'BYO-cloud (customer infra)',
};

export const DROPLET_SIZE_COST: Record<DropletSize, number> = {
  shared: 0.5,
  's-1vcpu-2gb': 12,
  's-2vcpu-4gb': 24,
  's-4vcpu-8gb': 48,
  's-8vcpu-16gb': 96,
  's-16vcpu-32gb': 192,
  byo: 0,
};
